import { useContext, useMemo } from "react";

import { AppContext } from "../../../core/context/appContextProvider";
import RoutingPaths from "../../../core/routing/routingPaths";
import { useClientEffect } from "../../../services/hooks/useClientsEffect/useClientEffect.hooks";

export const usepageMenuOptions = () => {
  const { state } = useContext(AppContext);

  const clientId = state.loginUser.clientId;
  const { client } = useClientEffect(clientId !== "new" ? clientId : undefined);
  const menu = useMemo(() => {
    return [
      {
        id: RoutingPaths.FundDetails,
        name: "Details",
        path: RoutingPaths.FundDetails,
      },
      {
        id: "performance",
        name: "Performance",
        path: "xx",
        hidden: true,
      },
      {
        id: "investments",
        name: "Investments",
        locked: client?.soiLocked === false ? false : true || true,
        menuOptions: [
          {
            id: "schedule_of_investments",
            name: "Schedule of Investments",
            path: RoutingPaths.ScheduleOfInvestmentsFund,
          },
          {
            id: "investment_companies",
            name: "Portfolio Companies",
            path: RoutingPaths.FundPortfolioCompanies,
          },
          {
            id: "investment_transactions",
            name: "Investment Transactions",
            path: RoutingPaths.InvestmentTransactionsFund,
          },
        ],
      },
      {
        id: "partners",
        name: "Partners",
        path: "xx",
        hidden: true,
      },
      {
        id: "capital_activity",
        name: "Capital Activity",
        path: "xx",
        hidden: true,
      },
      {
        id: "partners_capital",
        name: "Partner's Capital",
        hidden: true,
        menuOptions: [
          {
            id: "capital_accounts",
            name: "Capital Accounts",
            path: "xx",
          },
          {
            id: "quarters_management",
            name: "Quarters Management",
            path: "xx",
          },
        ],
      },
      {
        id: "general_ledger",
        name: "General Ledger",
        locked: client?.glLocked === false ? false : true || true,
        menuOptions: [
          {
            id: RoutingPaths.TransactionMapper,
            name: "Setup",
            path: RoutingPaths.TransactionMapper,
          },
          {
            id: "journal_entries",
            name: "Journal Entries",
            hidden: true,
            path: "xx",
          },
        ],
      },
      {
        id: RoutingPaths.FundAllocationsList,
        name: "Allocation Files",
        path: RoutingPaths.FundAllocationsList,
        locked: client?.allocationLocked === false ? false : true || true,
      },
      {
        id: RoutingPaths.FundInvestorList,
        name: "Investors",
        path: RoutingPaths.FundInvestorList,
        hidden: true,
      },
    ];
  }, [client]);

  return {
    menu,
  };
};
